import { BindAll } from 'lodash-decorators'
import { EnumApiHomework } from '@xt/client/api'
import { AjaxBasics } from '../../helpers/ajaxBasics'
import { PagePagination } from '@xt/client/utils/infinite-loading/index'

export type AllMomentItem = {
  commentCount: number
  id: string
  like: boolean | null
  likeCount: number | null
  createTime: number
  title: string
  content: string
  videoUrl: string
  pictures: Array<{
    originUrl: string
    waterUrl: string
    originWidth: number
    originHeight: number
  }>
  viewCount: number | null
}

@BindAll()
export class ControllerVideoV2 {
  constructor(protected $ajax: AjaxBasics) {}

  /**
   * 分页列表数据v2
   * @memberof ControllerVideoV2
   */
  pagePagination = new PagePagination<AllMomentItem>({
    url: EnumApiHomework.AllMoments
  })
}
